/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Custom Mega Menu - Hide on Link Click and Page Navigation
 * Fixes issue where mega menu stays visible after navigation
 */
(function() {
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenuFix);
  } else {
    initMegaMenuFix();
  }

  function initMegaMenuFix() {
    var megaMenuTrigger = document.querySelector('.Header__MegaMenuTrigger');
    var megaMenu = document.querySelector('.CustomMegaMenu');

    if (!megaMenuTrigger || !megaMenu) {
      return;
    }

    // Hide mega menu when any link inside it is clicked
    var megaMenuLinks = megaMenu.querySelectorAll('a');
    megaMenuLinks.forEach(function(link) {
      link.addEventListener('click', function() {
        // Force hide the mega menu immediately
        megaMenu.style.opacity = '0';
        megaMenu.style.visibility = 'hidden';
        megaMenu.style.transform = 'translateY(-15px)';
      });
    });

    // Hide mega menu before page unload (for better UX)
    window.addEventListener('beforeunload', function() {
      if (megaMenu) {
        megaMenu.style.opacity = '0';
        megaMenu.style.visibility = 'hidden';
        megaMenu.style.transform = 'translateY(-15px)';
      }
    });

    // Reset mega menu state when mouse leaves the trigger area
    megaMenuTrigger.addEventListener('mouseleave', function() {
      // Small delay to allow CSS transition
      setTimeout(function() {
        megaMenu.style.opacity = '';
        megaMenu.style.visibility = '';
        megaMenu.style.transform = '';
      }, 300);
    });
  }
})();

/**
 * Product Page Header Hide on Scroll (Desktop Only)
 * When enabled, hides header when scrolling down and shows when scrolling up
 */
(function() {
  // Check if feature is enabled
  if (!window.theme || !window.theme.productPageHeaderHideOnScroll) {
    return;
  }

  // Check if we're on a product page
  var body = document.body;
  if (!body.classList.contains('template-product')) {
    return;
  }

  // Only run on desktop (min-width: 1000px)
  var desktopMediaQuery = window.matchMedia('(min-width: 1000px)');

  var header = document.querySelector('.shopify-section--header');
  if (!header) {
    return;
  }

  var lastScrollTop = 0;
  var headerHeight = header.offsetHeight;
  var isHeaderHidden = false;
  var ticking = false;

  // Add CSS transition for smooth animation
  header.style.transition = 'transform 0.3s ease-in-out';
  header.style.willChange = 'transform';

  function updateHeader() {
    // Only apply on desktop
    if (!desktopMediaQuery.matches) {
      // Reset header position on mobile/tablet
      header.style.transform = 'translateY(0)';
      isHeaderHidden = false;
      return;
    }

    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // Scrolling down
    if (scrollTop > lastScrollTop && scrollTop > headerHeight) {
      if (!isHeaderHidden) {
        header.style.transform = 'translateY(-100%)';
        isHeaderHidden = true;
      }
    }
    // Scrolling up
    else if (scrollTop < lastScrollTop) {
      if (isHeaderHidden) {
        header.style.transform = 'translateY(0)';
        isHeaderHidden = false;
      }
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }

  // Listen for scroll events
  window.addEventListener('scroll', onScroll, { passive: true });

  // Listen for resize to handle desktop/mobile switch
  desktopMediaQuery.addEventListener('change', function() {
    if (!desktopMediaQuery.matches) {
      header.style.transform = 'translateY(0)';
      isHeaderHidden = false;
    }
  });
})();